export default {
  product: 'Produto',
  service: 'Serviço',
  options: [
    { value: 'product', text: 'Produto' },
    { value: 'service', text: 'Serviço' }
  ]
};
